module.exports = __webpack_public_path__ + "img/white-bean-dip.1a36801e.jpg";